import { render, staticRenderFns } from "./GoogleCirclesCommunities.vue?vue&type=template&id=164c14d9"
import script from "./GoogleCirclesCommunities.vue?vue&type=script&lang=js"
export * from "./GoogleCirclesCommunities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports